<template>
  <el-dialog
  :visible="forbiddenDialogVisible"
  :width="'450px'"
  :show-close="false"
  top="30vh"
  @close="onclose"
  >
    <div class="dialog-container">
        <div class="topTitle">
            <p>您的账号已被<img src="@/assets/image/Login/forbidden.png" alt="">用</p>
            <p>暂时无法登陆...</p>
        </div>
        <el-divider></el-divider>
        <div class="bottomTel">
            <div class="rightText">
                <p class="text">如需解封请拨打联系电话!</p>
                <p v-for="item in forbiddenTelList" :key="item">{{item}}</p>
            </div>
            <div class="rightBtn">
                <el-button round @click="onclose">关闭</el-button>
            </div>
        </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
    name:'ForbiddenDialog',
    data(){
        return {
           
        }
    },
    props:{
        forbiddenDialogVisible:{
            type: Boolean,
            default:false
        },
        forbiddenTelList:{
            type: Array,
            default:()=>{
                return []
            }
        }
    },
    methods:{
        onclose(){
            this.$emit('update:forbiddenDialogVisible',false)
        }
    }
}
</script>

<style lang="less" scoped>
    /deep/ .el-dialog{
        border-radius: 4px;
        overflow: hidden;
    }
    /deep/.el-dialog__body {     
        padding:0;
    }
    .dialog-container{
        padding:0 15px 27px;
        
        background:url('../../../assets/image/Login/forbiddenBg.png') no-repeat ;
        background-size: contain;
        background-position: right bottom;
        .topTitle{
            margin-left: 35px;
            margin-bottom: -9px;
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 23px;
            p{
                margin: 0;
            }
            img{
                vertical-align: bottom;
                width: 22px;
                height: 22px;
            }
        }
        .bottomTel{
            position: relative;
            margin-top: -9px;
            padding-left: 35px;
            display: flex;
            p{  
                margin: 0 0 5px;
                font-size: 18px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 21px;
                &.text{
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 19px;
                    margin-bottom: 15px;
                }
            }
            .rightBtn{
                position: absolute;
                bottom: 0;
                right:17px;
                /deep/ .el-button{
                    width: 100px;
                    height: 38px;
                }
                /deep/.el-button.is-round{
                    background-color: var(--bg-dark);
                    border-color: var(--bg-dark);
                    color: #fff;
                    transition: background-color 0.2s var(--ease);
                }
                /deep/.el-button.is-round:hover{
                    background-color: var(--primary);
                    border-color: var(--primary);
                }
            }
        }
    }
</style>